import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import LocalFireDepartmentRoundedIcon from '@mui/icons-material/LocalFireDepartmentRounded';
import CalendarTodayRoundedIcon from '@mui/icons-material/CalendarTodayRounded';
import EmojiEventsRoundedIcon from '@mui/icons-material/EmojiEventsRounded';

const glassStyle = {
  background: 'rgba(255,255,255,0.05)',
  border: '1px solid rgba(255,255,255,0.10)',
  borderRadius: '16px',
  backdropFilter: 'blur(12px)',
  padding: '20px 24px',
};

const StatItem = ({ icon, label, value, sub }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 1 }}>
    <Box sx={{ color: 'rgba(255,255,255,0.5)', display: 'flex', alignItems: 'center' }}>{icon}</Box>
    <Box sx={{ flex: 1 }}>
      <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.75rem' }}>
        {label}
      </Typography>
    </Box>
    <Box sx={{ textAlign: 'right' }}>
      <Typography variant="body1" sx={{ color: 'white', fontWeight: 700, fontSize: '1rem' }}>
        {value}
      </Typography>
      {sub && (
        <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.7rem' }}>
          {sub}
        </Typography>
      )}
    </Box>
  </Box>
);

/**
 * Displays today's and weekly focus statistics.
 *
 * Props:
 *  stats: { todayFocusCount, todayFocusMinutes, weekFocusCount, weekFocusMinutes, allTimeFocusCount }
 */
const TimerStats = ({ stats }) => {
  if (!stats) return null;

  const { todayFocusCount, todayFocusMinutes, weekFocusCount, weekFocusMinutes, allTimeFocusCount } = stats;

  return (
    <Box sx={{ width: '100%', maxWidth: 360, mx: 'auto', mt: 1 }}>
      <Box sx={glassStyle}>
        <Typography
          variant="caption"
          sx={{ color: 'rgba(255,255,255,0.4)', textTransform: 'uppercase', letterSpacing: 1, fontSize: '0.7rem' }}
        >
          Your Progress
        </Typography>

        <Box sx={{ mt: 1.5 }}>
          <StatItem
            icon={<LocalFireDepartmentRoundedIcon sx={{ fontSize: 18 }} />}
            label="Today"
            value={`🍅 × ${todayFocusCount}`}
            sub={todayFocusMinutes > 0 ? `${todayFocusMinutes} min focused` : 'No sessions yet'}
          />
          <Divider sx={{ borderColor: 'rgba(255,255,255,0.07)', my: 0.5 }} />
          <StatItem
            icon={<CalendarTodayRoundedIcon sx={{ fontSize: 18 }} />}
            label="This week"
            value={`🍅 × ${weekFocusCount}`}
            sub={weekFocusMinutes > 0 ? `${Math.round(weekFocusMinutes / 60 * 10) / 10}h focused` : 'No sessions yet'}
          />
          <Divider sx={{ borderColor: 'rgba(255,255,255,0.07)', my: 0.5 }} />
          <StatItem
            icon={<EmojiEventsRoundedIcon sx={{ fontSize: 18 }} />}
            label="All time"
            value={`🍅 × ${allTimeFocusCount}`}
            sub="total sessions"
          />
        </Box>
      </Box>
    </Box>
  );
};

export default TimerStats;
